module.exports = __webpack_public_path__ + "static/media/greyMarker.c0d09005.svg";